import React from 'react';
import { colors, radii, shadows } from '../../theme/tokens';

const Card = ({ padding = 24, radius = radii.card, shadow = true, style, children, as: Tag = 'div', ...rest }) => (
  <Tag
    style={{
      boxSizing: 'border-box',
      background: colors.white,
      border: '1px solid ' + colors.border,
      borderRadius: radius,
      padding,
      boxShadow: shadow ? shadows.card : 'none',
      minWidth: 0,
      ...style,
    }}
    {...rest}
  >
    {children}
  </Tag>
);

export default Card;
